export class Injector {
  private map: Map<string, unknown> = new Map();

  /**
   * A service locator: the caller names the type it registered under this key. That is the one
   * assertion the injector makes, and it is made here rather than through an `any` map.
   */
  public get<T>(key: string): T {
    return this.map.get(key) as T;
  }

  public set<T>(key: string, value: T): void {
    this.map.set(key, value);
  }
}

export const injector = new Injector();
